export default function PaymentFailed() {
    return (<h1>Payment Failed</h1>)
}